
























































































import {Component, Vue} from "vue-property-decorator";
import SearchSegmentation from "@/views/SearchSegmentation.vue";
import {integer} from "@/components/filters/Integer";
import {NullPointerException, StateMachine} from "frontend-core";
import {Agent} from "@/models/Agent";
import {ISegmentationTargetService} from "@/modules/Segmentation/services/ISegmentationTargetService";
import {container} from "@/services/registerServiceProvider";
import {SegmentationTarget} from "@/modules/Segmentation/models/SegmentationTarget";

@Component({
    components: {SearchSegmentation},
    filters: {
        int: integer
    },
})
export default class SegmentationNestingChange extends Vue {
    isNesting: boolean = true;

    public readonly stateMachine: StateMachine = new StateMachine("idle", {
        idle: ["loading"],
        loading: ["idle"],
    });
    public selectedArray: Agent[] = [];
    public progress: number = 0;

    private readonly segmentationTargetService: ISegmentationTargetService = container.resolve("ISegmentationTargetService");

    setSelectedArray(val: unknown[]): void {
        this.selectedArray.splice(
            0,
            this.selectedArray.length,
            ...val.filter<Agent>((i): i is Agent => i instanceof Agent),
        );
    }

    selectAgent(agent: Agent) {
        if (!this.selectedArray.map(i => i.id).includes(agent.id)) {
            this.selectedArray.push(agent);
        }
    }

    cancel(): void {
        this.stateMachine.transition("idle");
    }

    async change() {
        const totalLength: number = this.selectedArray.length;
        this.progress = 0;

        this.stateMachine.transition("loading");

        while (this.selectedArray.length > 0 && this.stateMachine.state === "loading") {
            let subOperationsCount: number = 3;
            let subOperationsCompleted: number = 0;

            const progressPartial: number = 1 / totalLength * 100;

            const agent: Agent = this.selectedArray[0];

            let progressWas: number = this.progress;

            const segmentation: SegmentationTarget | null = await this.segmentationTargetService
                .getByAgentId(agent.id);

            if (!segmentation) {
                throw new NullPointerException();
            }

            subOperationsCompleted += 1;
            this.progress = progressWas + this.incrementProgress(
                subOperationsCompleted,
                subOperationsCount,
                progressPartial,
            );

            subOperationsCount += 1;

            progressWas = this.progress;

            if (segmentation.parentId && !this.isNesting) {
                await this.segmentationTargetService.unLock(segmentation);
            } else if (!segmentation.parentId && this.isNesting) {
                await this.segmentationTargetService.lock(segmentation, agent);
            }

            subOperationsCompleted += 1;
            this.progress = progressWas + this.incrementProgress(
                subOperationsCompleted,
                subOperationsCount,
                progressPartial,
            );

            this.selectedArray.splice(this.selectedArray.indexOf(agent), 1);

            this.progress = 100 * (totalLength - this.selectedArray.length) / totalLength;
        }

        this.stateMachine.transition("idle");
    }

    private incrementProgress(
        subOperationsCompletedLength: number,
        subOperationsCount: number,
        operationProgress: number,
    ): number {
        return subOperationsCompletedLength / subOperationsCount * operationProgress;
    }

}
